import { Component, Story, Knobs, Accents } from './DocTypes';

const BasicKnobs: Knobs = {
  value: {
    default: undefined,
    editor: 'textbox',
    delimiter: '\n  ',
  },
  placeholder: {
    default: '',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  disabled: {
    default: false,
    editor: 'checkbox',
    delimiter: '\n  ',
  },
  inputDisabled: {
    default: false,
    editor: 'checkbox',
    delimiter: '\n  ',
  },
  borderless: {
    default: false,
    editor: 'checkbox',
    delimiter: '\n  ',
  },
  clearButton: { default: false, editor: 'checkbox', delimiter: '\n  ' },
  firstDayOfWeek: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', '0', '1', '2', '3', '4', '5', '6'],
    delimiter: '\n  ',
  },
  locale: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'en-GB', 'en-US'],
    delimiter: '\n  ',
  },
  formattingOptions: {
    default: '',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  inputStyle: {
    default: '',
    editor: 'textbox',
    delimiter: '\n  ',
  },
};

const v3Knobs: Knobs = {
  'colour-scheme': {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
  },
  device: {
    editor: 'dropdown',
    editorOptions: ['mobile', 'desktop', ''],
    default: '',
  },
};
const BasicStory: Story = {
  title: 'Basic',
  description: 'A basic tag-date-picker where you can change the key attributes',
  coreComponent: {
    html: `<tag-date-picker{{...knobs}}>
</tag-date-picker>`,
    knobs: BasicKnobs,
  },
  reactWrapper: {
    jsx: `<TagDatePicker{{...knobs}}
/>`,
    knobs: BasicKnobs,
  },
  coreComponent_v3: {
    html: `<tag3-date-picker name='dp1' {{...knobs}}>
  </tag3-date-picker>`,
    knobs: {
      ...BasicKnobs,
      ...v3Knobs,
      accent: {
        default: 'access',
        editor: 'dropdown',
        editorOptions: [''].concat(Accents),
      },
    },
  },
  reactWrapper_v3: {
    jsx: `<Tag3DatePicker {{...knobs}} />`,
    knobs: {
      ...BasicKnobs,
      ...v3Knobs,
      accent: {
        default: 'access',
        editor: 'dropdown',
        editorOptions: [''].concat(Accents),
      },
    },
  },
};

const CustomKnobs: Knobs = {
  accent: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
};

const BorderlessKnobs: Knobs = {
  value: {
    default: undefined,
    editor: 'textbox',
    delimiter: '\n  ',
  },
  placeholder: {
    default: 'Enter a date',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  disabled: {
    default: false,
    editor: 'checkbox',
    delimiter: '\n  ',
  },
  clearButton: { default: false, editor: 'checkbox', delimiter: '\n  ' },
  firstDayOfWeek: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', '0', '1', '2', '3', '4', '5', '6'],
    delimiter: '\n  ',
  },
  locale: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'en-GB', 'en-US'],
    delimiter: '\n  ',
  },
  formattingOptions: {
    default: '',
    editor: 'textbox',
    delimiter: '\n  ',
  },
};
const BorderlessStory: Story = {
  title: 'Borderless',
  description: 'A tag-date-picker that has no border which is useful for small forms',
  coreComponent: {
    html: `<tag-date-picker
  borderless
  input-disabled{{...knobs}}>
</tag-date-picker>`,
    knobs: BorderlessKnobs,
  },
  reactWrapper: {
    jsx: `<TagDatePicker
  borderless
  input-disabled{{...knobs}}
/>`,
    knobs: BorderlessKnobs,
  },
  coreComponent_v3: {
    html: `<tag3-date-picker
  borderless
  input-disabled{{...knobs}}>
</tag3-date-picker>`,
    knobs: BorderlessKnobs,
  },
  reactWrapper_v3: {
    jsx: `<Tag3DatePicker
  borderless
  input-disabled{{...knobs}}
/>`,
    knobs: BorderlessKnobs,
  },
};

const ModalStory: Story = {
  title: 'Modal',
  description: 'A tag-date-picker in a modal dialog',
  coreComponent: {
    html: `<tag-modal visible heading='Date in modal'>
  <div style="position: relative">
    <tag-date-picker placeholder='Enter a date' />
  </div>
</tag-modal>`,
  },
  coreComponent_v3: {
    html: `<tag-modal visible heading='Date in modal'>
  <div style="position: relative">
    <tag3-date-picker name='dp' placeholder='Enter a date' />
  </div>
</tag-modal>`,
  },
  reactWrapper: {
    jsx: `<TagModal visible heading='Date in modal'>
  <div style={{position: "relative"}}>
    <TagDatePicker placeholder='Enter a date' />
  </div>
</TagModal>`,
  },
  reactWrapper_v3: {
    jsx: `<TagModal visible heading='Date in modal'>
  <div style={{position: "relative"}}>
    <Tag3DatePicker name='dp' placeholder='Enter a date' />
  </div>
</TagModal>`,
  },
};

const ScrollContainerStory: Story = {
  title: 'Scroll container',
  description: 'Several date pickers in a scroll container',
  coreComponent: {
    html: `<div style="height:120px; overflow:auto;">
  <div style="margin-bottom:15px;">
    <tag-date-picker placeholder='Enter date'></tag-date-picker>
  </div>
  <div style="margin-bottom:15px;">
    <tag-date-picker placeholder='Enter date'></tag-date-picker>
  </div>
  <div style="margin-bottom:15px;">
    <tag-date-picker placeholder='Enter date'></tag-date-picker>
  </div>
</div>`,
  },
  coreComponent_v3: {
    html: `<div style="height:120px; overflow:auto;">
  <div style="margin-bottom:15px;">
    <tag3-date-picker name='dp1' placeholder='Enter date'></tag-date-picker>
  </div>
  <div style="margin-bottom:15px;">
    <tag3-date-picker name='dp2' placeholder='Enter date'></tag-date-picker>
  </div>
  <div style="margin-bottom:15px;">
    <tag3-date-picker name='dp3' placeholder='Enter date'></tag-date-picker>
  </div>
</div>`,
  },
  reactWrapper: {
    jsx: `<div style={{height: "120px", overflow: "auto"}}>
  <div style={{marginBottom: "15px"}}>
    <TagDatePicker placeholder='Enter date' />
  </div>
  <div style={{marginBottom: "15px"}}>
    <TagDatePicker placeholder='Enter date' />
  </div>
  <div style={{marginBottom: "15px"}}>
    <TagDatePicker placeholder='Enter date' />
  </div>
</div>`,
  },
  reactWrapper_v3: {
    jsx: `<div style={{height: "120px", overflow: "auto"}}>
  <div style={{marginBottom: "15px"}}>
    <Tag3DatePicker name='dp1' placeholder='Enter date' />
  </div>
  <div style={{marginBottom: "15px"}}>
    <Tag3DatePicker name='dp2' placeholder='Enter date' />
  </div>
  <div style={{marginBottom: "15px"}}>
    <Tag3DatePicker name='dp3' placeholder='Enter date' />
  </div>
</div>`,
  },
};

const Custom: Story = {
  title: 'Custom date-picker',
  description:
    'You can have a date-picker-box with or without an input, outside of a popover, basically it is very customizable',
  coreComponent_v3: {
    html: `<tag3-input></tag3-input>
    <tag3-date-picker-box {{...knobs}}/> `,
    js: `
    var input = document.querySelector("tag3-input");
    var dp = document.querySelector("tag3-date-picker-box");
    dp.addEventListener('datePickerBoxValueChange', function(e) {
      dp.value = e.detail.value;
      input.value = e.detail.value;
    })
    `,
    knobs: CustomKnobs,
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `const Example = () => {
      const [value, setValue] = React.useState('');
      const [dateValue, setDateValue] = React.useState(new Date());
      const handleValueChange = (e) => {
        setDateValue(e.detail.value);
        setValue(e.detail.value.toString());
      }
  return (
    <div>
      <Tag3Input value={value}></Tag3Input>
      <Tag3DatePickerBox {{...knobs}} value={dateValue} onDatePickerBoxValueChange={handleValueChange}></Tag3DatePickerBox>
    </div>
  )
};`,
    knobs: CustomKnobs,
  },
};

export const TagDatePickerDocs: Component = {
  type: 'component',
  name: 'date-picker',
  description: 'Renders a date picker',
  mobileFriendly: false,
  popular: true,
  preRelease: '',
  props: [
    {
      name: 'inputId',
      description: 'The id given to the internal input',
      type: 'string',
    },
    {
      name: 'accent',
      description: 'The accent of the selected day. Available in v3.',
      type: 'Accent',
    },
    {
      name: 'name',
      description: 'The name given to the internal input',
      type: 'string',
    },
    {
      name: 'value',
      description: 'The value',
      type: 'string',
    },
    {
      name: 'placeholder',
      description: 'The placeholder text',
      type: 'string',
    },
    {
      name: 'disabled',
      description: 'Whether element is disabled',
      type: 'boolean',
    },
    {
      name: 'inputDisabled',
      description:
        'Whether the internal input element is disabled. This prevents the user from typing into the element',
      type: 'boolean',
      default: 'false',
    },
    {
      name: 'borderless',
      description: 'Whether the internal input has its border removed',
      type: 'boolean',
      default: 'false',
    },
    {
      name: 'inputStyle',
      description: 'JSX style object in JSON to apply to the internal input',
      type: 'boolean',
      default: 'false',
    },
    {
      name: 'firstDayOfWeek',
      description: 'The day number for today. 0 is sunday',
      type: '0 | 1 | 2 | 3 | 4 | 5 | 6',
      default: '1',
    },
    {
      name: 'locale',
      description: 'The locale for the calendar',
      type: 'en-GB | en-US',
      default: 'en-GB',
    },
    {
      name: 'formattingOptions',
      description:
        'Additional formatting options for dates. This maps directly to the options parameter in Intl.DateTimeFormat see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat',
      type: 'string',
    },

    {
      name: 'suppressPopoverArrow',
      description: 'Whether to suppress the popover arrow',
      type: 'boolean',
    },

    {
      name: 'popoverArrowAccent',
      description: 'The accent of the popover arrow',
      type: 'string',
    },
    {
      name: 'clearButton',
      description: 'The boolean which tells us if the clear button does exist',
      type: 'boolean',
    },
    {
      name: 'colour-scheme',
      description:
        'V3 Only: Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'light',
    },
    {
      name: 'device',
      description: 'V3 Only: Set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'desktop',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'valueChange',
      description: 'V1 only: Triggers when the field value changes',
      parameters: [
        {
          name: 'value',
          description: 'The new date value',
          type: 'string | Date',
        },
      ],
    },
    {
      name: 'datePickerValueChange',
      description: 'V3 only: Triggers when the field value changes',
      parameters: [
        {
          name: 'value',
          description: 'The new date value',
          type: 'string | Date',
        },
      ],
    },
    {
      name: 'datePickerInputFocus',
      description: 'V3 only: Triggers when the input gains focus',
      parameters: [
        {
          name: 'name',
          description: 'The value of the name prop',
          type: 'string',
        },
      ],
    },
    {
      name: 'datePickerInputBlur',
      description: 'V3 only: Triggers when the input loses focus',
      parameters: [
        {
          name: 'name',
          description: 'The value of the name prop',
          type: 'string',
        },
      ],
    },
  ],
  methods: [
    {
      name: 'focusInput',
      description: 'Sets the focus to the date picker input',
      parameters: [],
      returnType: 'void',
    },
    {
      name: 'select',
      description: 'Selects the text in the date picker input',
      parameters: [],
      returnType: 'void',
    },
    {
      name: 'setValue',
      description: 'Sets the date value with optional change event suppression',
      parameters: [
        {
          name: 'date',
          description: 'The new date value',
          type: 'Date | string',
        },
        {
          name: 'suppressEvent',
          description: 'If set to true will not trigger change event. defaults to false.',
          type: 'boolean',
        },
      ],
      returnType: 'void',
    },
  ],
  stories: [BasicStory, BorderlessStory, ModalStory, ScrollContainerStory, Custom],
};
